import axios from 'axios'

const baseUrl = '/api/tests'

export class TestService {
    // Get tests
    static getVehicleTestsPaged(pageSize, requestPage, searchTerm) {
        return new Promise(async (resolve, reject) => {
            try {
                pageSize = pageSize || 10
                requestPage = requestPage || 0                
                searchTerm = searchTerm ? `&searchTerm=${searchTerm}` : ''
                let url = `${baseUrl}/?limit=${pageSize}&page=${requestPage}${searchTerm}`
                let results = await axios.get(url)
                resolve(results.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }

     // Get tests by Client Id
     static getVehicleTestsByClientIdPaged(clientId, pageSize, requestPage) {
        return new Promise(async (resolve, reject) => {
            try {
                pageSize = pageSize || 10
                requestPage = requestPage || 0
                let url = `${baseUrl}/?clientId=${clientId}&limit=${pageSize}&page=${requestPage}`
                let results = await axios.get(url)
                resolve(results.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }
    
    // Get test by Id
    static getVehicleTestById(testId) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = `${baseUrl}/${testId}`
                let result = await axios.get(url)
                resolve(result.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }
}